import { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import cancelIcon from '~images/Ruksi_ikoni_valkoinen.svg';

import ProfileUnitChange from './ProfileUnitChange';

const propTypes = {
  user: PropTypes.object.isRequired,
  userOrganizations: PropTypes.array.isRequired,
  addFollowedOrganization: PropTypes.func.isRequired,
};

class AddFollowedUnit extends Component {
  state = {
    open: false,
  };

  toggleOpen = () => {
    this.setState({ open: !this.state.open });
  };

  handleSelect = id => {
    this.toggleOpen();
    this.props.addFollowedOrganization(id);
  };

  render() {
    const { user, userOrganizations } = this.props;
    return (
      <Wrapper>
        <SelectWrapper hidden={!this.state.open}>
          <ProfileUnitChange
            user={user}
            userOrganizations={userOrganizations}
            onUnitSelect={this.handleSelect}
          />
          <CancelIcon src={cancelIcon} onClick={this.toggleOpen} />
        </SelectWrapper>
        {!this.state.open && (
          <Label onClick={this.toggleOpen}>
            <AddIcon icon={faPlus} />
            <span>Lisää osasto</span>
          </Label>
        )}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: block;
`;

const SelectWrapper = styled.div`
  display: ${props => (props.hidden ? 'hidden' : 'flex')};
  align-items: flex-start;
`;

const Label = styled.div`
  color: white;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 4px;
  font-size: 12px;
`;

const AddIcon = styled(FontAwesomeIcon)`
  font-size: 17px;
  margin-right: 12px;
`;

const CancelIcon = styled.img`
  width: 11px;
  margin-right: -24px;
  margin-left: 12px;
  cursor: pointer;
  margin-top: 16px;
`;

AddFollowedUnit.propTypes = propTypes;

export default AddFollowedUnit;
